import { useEffect } from 'react';
import { useLayoutStore } from '@/app/layouts/use-layout-store';

/** Enquanto a tela estiver aberta, o conteudo usa a largura toda da janela. */
export function useFullWidth() {
  const setFullWidth = useLayoutStore((state) => state.setFullWidth);

  useEffect(() => {
    setFullWidth(true);

    return () => setFullWidth(false);
  }, [setFullWidth]);
}
